import get from './selection'

export type { Params as SelectionDictionaryParams, EndPoints as SelectionDictionaryEndPoints } from './selection'

const services = {
  get,
}

export default services
